var exports = {
  "jW": "x31de4314--36a6ab--photo",
  "pq": "x31de4314--36a6ab--info",
  "q9": "x31de4314--36a6ab--price",
  "nf": "x31de4314--36a6ab--link",
};

module.exports = exports;
